
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"stroke":"#292D32","viewBox":"0 0 56 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.968 30.16a.605.605 0 00-.19 0 2.573 2.573 0 01-2.48-2.58c0-1.43 1.15-2.58 2.58-2.58a2.58 2.58 0 012.58 2.58c-.01 1.4-1.11 2.54-2.49 2.58zM21.058 33.31c-1.41.94-1.41 2.48 0 3.42 1.6 1.07 4.22 1.07 5.82 0 1.41-.94 1.41-2.48 0-3.42-1.59-1.06-4.22-1.06-5.82 0zM35 21.902a.461.461 0 00-.144 0 1.946 1.946 0 01-1.875-1.951 1.95 1.95 0 113.902 0c-.008 1.058-.84 1.92-1.883 1.95zM32.8 24.284c-1.066.71-1.066 1.875 0 2.586 1.21.809 3.19.809 4.4 0 1.067-.711 1.067-1.876 0-2.586-1.202-.802-3.19-.802-4.4 0z","stroke":"inherit","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M31.5 32L30 33.25l1.5 1.25","stroke":"inherit","stroke-width":".9","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M30 33.25c2.167 0 6.5-.25 6-4.25","stroke":"inherit","stroke-width":".9","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M29.54 20.5l1.5-1.25-1.5-1.25","stroke":"inherit","stroke-width":".9","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M31.04 19.25c-2.167 0-6.5.25-6 4.25","stroke":"inherit","stroke-width":".9","stroke-linecap":"round"}})])
          )
        }
      }
    